module.exports = __webpack_public_path__ + "img/titlePc29-safeimagekit.10910c7b.png";